<template>
  <el-form ref="form" v-bind="$attrs" :id="`yblForm-${index}`" v-on="$listeners" class="screen-form" slot="head">
    <slot></slot>
  </el-form>
</template>
<script>
export default {
  name: 'yblForm',
  props: {
    index: {
      type: Number | String,
      default: () => 0
    }
  },
  data () {
    return {
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
    resetFields () {
      const $form = this.$refs.form
      if ($form) {
        $form.resetFields()
      }
    }
  }
}
</script>
<style lang="less" scoped>
@import "../assets/less/color.less";
.screen-form {
  // display: flex;
  // max-height: 100px;
  // min-height: 53px;
  // overflow: auto;
  // overflow-y: auto;
  // padding: 0 16px;
  // padding-top: 6px;
  // padding-left: 12px;
  background-color: #fff;
  box-sizing: border-box;
  flex: 0 1 auto;
  /deep/.el-form-item {
    // margin-bottom: 12px;
    // margin-right: 12px;
    padding: 12px 0 0 0;
    margin-bottom: 0;
    margin-right: 0;
    // width: 300px;
  }
  /deep/.el-form-item__label {
    font-size: 12px;
    color: @routine-color;
    padding-right: 1px;
    font-weight: 500;
  }
  /deep/.el-input {
    width: 190px;
    min-width: 190px;
    font-family: Microsoft YaHei;
    .el-input__inner {
      &::-webkit-input-placeholder {
        font-size: 12px;
        color: @placeholder-color;
      }
    }
  }
  /deep/.filter-field {
    min-width: 224px;
    display: flex;
    align-items: center;
    .filter-model-dropdown {
      width: 32px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
      cursor: pointer;
      background-color: #fff;
      border: 1px solid #dde0e6;
      border-radius: 2px 0px 0px 2px;
      border-right: none;
      flex: none;
      .el-dropdown-link {
        padding: 6px;
        color: #a4a5a7;
        line-height: 1;
        width: 14px;
        height: 14px;
        text-align: center;
      }
    }
    .el-input {
      .el-input__inner {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
        border-top-right-radius: 2px;
        border-bottom-right-radius: 2px;
      }
    }
  }
  /deep/.area-container {
    .el-form-item {
      padding: 0;
      .el-input {
        width: 95px;
      }
      .el-input__inner {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }
    }
    .el-form-item + .el-form-item {
      // padding-left: 12px;
      .el-input__inner {
        border-left: none;
      }
    }
  }
  /deep/.num-range__box {
    width: 190px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  /deep/.num-range__box .el-input-number--small {
    width: 86px !important;
    .el-input-number__decrease {
      width: 21px;
    }
    .el-input-number__increase {
      width: 21px;
    }
    .el-input {
      min-width: 86px !important;
      width: 86px !important;
      .el-input__inner {
        padding-left: 28px;
        padding-right: 28px;
      }
    }
  }
  /deep/.form-search-button {
    margin-left: 12px;
  }
  /deep/.custom-date__box .el-date__right .el-input__inner {
    padding-left: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/form.vue